import * as types from '../actions/action-types';

const initialState = {
  items: [],
  loadingItems: null,
  errorLoadingItems: null,

  deletingItem: null,
  errorDeletingItem: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.BACKPACK_REQUEST_LIST_PENDING:
      return {
        ...state,
        loadingItems: true,
        errorLoadingItems: null
      };
    case types.BACKPACK_REQUEST_LIST_FULFILLED:
      return {
        ...state,
        items: action.payload.files,
        loadingItems: false,
        errorLoadingItems: null
      };
    case types.BACKPACK_REQUEST_LIST_REJECTED:
      return {
        ...state,
        loadingItems: false,
        errorLoadingItems: action.payload
      };

    case types.BACKPACK_DELETE_ITEM_PENDING:
      return {
        ...state,
        deletingItem: action.meta.id,
        errorDeletingItem: null
      };

    case types.BACKPACK_DELETE_ITEM_FULFILLED:
      // Remove the deleted item from the local store if it exists.
      return {
        ...state,
        deletingItem: null,
        errorDeletingItem: null,
        items: state.items.filter((item) => item.id !== action.meta.id)
      };

    case types.BACKPACK_DELETE_ITEM_REJECTED:
      return {
        ...state,
        deletingItem: null,
        errorDeletingItem: action.payload
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/backpack-reducer.js